import LightFilled16 from '@carbon/icons-react/es/light--filled/16';
import Light16 from '@carbon/icons-react/es/light/16';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { FormTheme, FormThemeImageType } from 'api/form/types';
import { ProgressBar } from 'components/molecules/progress-bar';
import { useFormTemplateUpdateMutation } from 'queries/form-template';
import { CustomImage } from './custom-image';

interface BackgroundImageProps {
  formTheme: FormTheme;
  templateId: number;
}

const Wrapper = styled.div`
  padding: var(--layout-02) var(--layout-01);
`;
const BrightnessValueWrapper = styled.div`
  padding-top: var(--spacing-05);
`;
const ProgressBarWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  .ant-input-number {
    display: none;
  }
  > .ant-space {
    width: 100%;
    > .ant-space-item:first-child {
      flex: 1;
    }
  }
`;

export const BackgroundImage: FC<BackgroundImageProps> = ({
  formTheme,
  templateId,
}) => {
  const [brightnessValue, setBrightnessValue] = useState<number>(
    formTheme.brightness ?? 0,
  );
  const { mutate } = useFormTemplateUpdateMutation(templateId);

  const onImageUpdate = (imageUrl: string) => {
    mutate({
      formTheme: {
        ...formTheme,
        backgroundImage: imageUrl,
      },
    });
  };

  const onBrightnessValueUpdate = () => {
    mutate({
      formTheme: {
        ...formTheme,
        brightness: brightnessValue,
      },
    });
  };

  return (
    <Wrapper>
      <FormattedMessage id="form_templates.background_image" />
      <CustomImage
        customImageLocation={formTheme.backgroundImage}
        imageType={FormThemeImageType.BackgroundImage}
        templateId={templateId}
        isSelected
        setImage={onImageUpdate}
      />
      {formTheme.backgroundImage ? (
        <BrightnessValueWrapper>
          <FormattedMessage id="form_templates.background_image.brightness" />
          <ProgressBarWrapper>
            <Light16 />
            <ProgressBar
              step={5}
              value={brightnessValue}
              onChange={(value) => {
                setBrightnessValue(value);
              }}
              onAfterChange={() => onBrightnessValueUpdate()}
              onInputPressEnter={(e) => e.currentTarget.blur()}
              onInputBlur={() => onBrightnessValueUpdate()}
            />
            <LightFilled16 />
          </ProgressBarWrapper>
        </BrightnessValueWrapper>
      ) : null}
    </Wrapper>
  );
};
